var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "po-content", attrs: { "data-testid": "po-row" } },
    [
      _c("div", { staticClass: "po__page mb-48" }, [
        _c("div", { staticClass: "row justify-content-between m-0" }, [
          _c(
            "div",
            {
              staticClass:
                "col-3 col-lg-3 content__total-row-border-less d-flex justify-content-between align-self-center align-items-center p-0 pr-8"
            },
            [
              _c("EpAddRowButton", {
                attrs: {
                  "data-testid": "bl-add-button",
                  isDisabled: _vm.shouldDisableAddButton
                },
                on: {
                  add: function($event) {
                    return _vm.$emit("add")
                  }
                }
              }),
              _c("EpLabel", { staticClass: "mb-0" }, [_vm._v("Total")])
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "col-9 col-lg-9 d-flex pl-lg-3 pr-0 align-self-center"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "EpLabel",
                    {
                      staticClass: "content__total-row mb-0",
                      class: {
                        "text-danger": _vm.blsCountExceedMax,
                        "border-danger": _vm.blsCountExceedMax
                      },
                      attrs: { "data-testid": "total-rows-text" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.blsCount) +
                          " / " +
                          _vm._s(_vm.maxBls) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]),
        _vm.blsCountExceedMax || _vm.posCountExceedMax
          ? _c(
              "div",
              { staticClass: "row m-0 mt-2 ep__laptop__display-error" },
              [
                _vm.blsCountExceedMax
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col align-self-center error-message text-left"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getTextByCountry(
                                _vm.countryCode,
                                "payPOPage_totalBLRecords_label_errorMsg_reachedMax",
                                [_vm.maxBls]
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.posCountExceedMax && !_vm.blsCountExceedMax
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col align-self-center error-message text-left"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getTextByCountry(
                                _vm.countryCode,
                                "payPOPage_totalPORecords_label_errorMsg_reachedMax",
                                [_vm.maxPos]
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm.blsCountExceedMax || _vm.posCountExceedMax
          ? _c(
              "div",
              { staticClass: "row ml-0 mr-0 mt-2 ep__tablet_display-error" },
              [
                _c("div", { staticClass: "col-3 col-lg-3" }),
                _c("div", { staticClass: "col-9 col-lg-9 align-self-center" }, [
                  _vm.blsCountExceedMax
                    ? _c("div", { staticClass: "error-message text-left" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getTextByCountry(
                                _vm.countryCode,
                                "payPOPage_totalBLRecords_label_errorMsg_reachedMax",
                                [_vm.maxBls]
                              )
                            ) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm.posCountExceedMax && !_vm.blsCountExceedMax
                    ? _c("div", { staticClass: "error-message text-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getTextByCountry(
                                _vm.countryCode,
                                "payPOPage_totalPORecords_label_errorMsg_reachedMax",
                                [_vm.maxPos]
                              )
                            ) +
                            " "
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }